// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__26O-B","search":"Settings_search__3XTnU","filter":"Settings_filter__3zZNT"};